import React, { useState } from "react"

const Form = ({
  fields,
  handleSubmit,
  className = "",
  initialData = {},
  submitButtonLabel = "Submit",
}) => {
  const [formData, setFormData] = useState(initialData)
  const [errors, setErrors] = useState({})
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitStatus, setSubmitStatus] = useState(null)

  const validateForm = () => {
    const newErrors = {}
    console.log('validation fields', fields);
    fields.forEach(({ name, required }) => {
      const value = formData[name]
      console.log('name', name,'value', value, 'required', required);
      if (required) {
        if (typeof value === "string" && !value.trim()) {
          newErrors[name] = `${name} is required`
        } else if (value === null || value === undefined || value === false) {
          newErrors[name] = `${name} is required`
        }
      }
    })
    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleInputChange = e => {
    const { name, value, type, checked } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }))
  }

  const handleFileChange = e => {
    const { name, files } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: files[0], // Store the File object
    }))
  }

  const handleCheckboxChange = e => {
    const { name, value, checked } = e.target
    setFormData(prev => {
      const prevValues = Array.isArray(prev[name]) ? prev[name] : []
      if (checked) {
        // Add the selected value
        return {
          ...prev,
          [name]: [...prevValues, value],
        }
      } else {
        // Remove the deselected value
        return {
          ...prev,
          [name]: prevValues.filter(v => v !== value),
        }
      }
    })
  }

  const onSubmit = async e => {
    e.preventDefault()
    if (!validateForm()) return

    setIsSubmitting(true)
    setSubmitStatus(null)
    try {
      await handleSubmit(formData)
      setSubmitStatus("success")
      setFormData(initialData)
      // Reset file inputs
      fields
        .filter(field => field.type === "file")
        .forEach(({ name }) => {
          const fileInput = document.querySelector(`input[name="${name}"]`)
          if (fileInput) fileInput.value = ""
        })
    } catch (error) {
      console.error("Submission error:", error)
      setSubmitStatus("error")
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <form onSubmit={onSubmit} className={`space-y-4 ${className}`}>
      {fields.map(
        ({
          label,
          name,
          type = "text",
          required,
          placeholder = false,
          options,
        }) => (
          <div key={name}>
            <label
              htmlFor={name}
              className="block text-sm font-medium text-gray-700"
            >
              {label} {required && "*"}
            </label>
            {type === "textarea" ? (
              <textarea
                id={name}
                name={name}
                value={formData[name] || ""}
                onChange={handleInputChange}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm"
              />
            ) : type === "checkbox" && options ? (
              options.map(option => (
                <label
                  key={option.value}
                  className="inline-flex items-center space-x-2"
                >
                  <input
                    type="checkbox"
                    id={`${name}-${option.value}`}
                    name={name}
                    value={option.value}
                    checked={
                      Array.isArray(formData[name]) &&
                      formData[name].includes(option.value)
                    }
                    onChange={handleCheckboxChange}
                    className="form-checkbox"
                  />
                  <span>{option.label}</span>
                </label>
              ))
            ) : type === "select" ? (
              <select
                id={name}
                name={name}
                value={formData[name] || ""}
                onChange={handleInputChange}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm"
              >
                {options.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            ) : type === "file" ? (
              <input
                type="file"
                id={name}
                name={name}
                onChange={handleFileChange}
                accept=".pdf,.doc,.docx"
                className="mt-1 block w-full"
              />
            ) : (
              <input
                type={type}
                id={name}
                name={name}
                placeholder={placeholder ? label : ""}
                value={formData[name] || ""}
                onChange={handleInputChange}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm"
              />
            )}
            {errors[name] && (
              <div className="text-red-500 text-sm">{errors[name]}</div>
            )}
          </div>
        )
      )}
      <button
        type="submit"
        disabled={isSubmitting}
        className=""
      >
        {isSubmitting ? "Submitting..." : submitButtonLabel}
      </button>
      {submitStatus === "success" && (
        <div className="text-green-600 text-center">
          Form submitted successfully!
        </div>
      )}
      {submitStatus === "error" && (
        <div className="text-red-600 text-center">
          Error submitting form. Please try again.
        </div>
      )}
    </form>
  )
}

export default Form
